import { environment } from 'src/environments/environment';
import { SharedParams } from './shared-params.const';

// Settings 5007
const SettingService = '/settings';

const ContactController = `${SettingService}/contacts`;
const CultureController = `${SettingService}/cultures`;
const CurrencyController = `${SettingService}/currencies`;
const CourseTabImageController = `${SettingService}/courses/tab-images`;
const HintController = `${SettingService}/hints`;
const TourController = `${SettingService}/tours`;
const DynamicSignUpFormController = `${SettingService}/dynamic-forms/signup`;
const HomeImageController = `${SettingService}/home/images/main`;
const HomeSectionController = `${SettingService}/home/sections`;
const IdentityController = `${SettingService}/identity`;
const LocalizationsController = `${SettingService}/localizations`;
const MessageCategoryController = `${SettingService}/messages/categories`;
const MessagingConfigController = `${SettingService}/messaging`;
const NotificationController = `${SettingService}/notifications`;
const OrganizationController = `${SettingService}/organizations`;
const PageController = `${SettingService}/pages`;
const PageFeedbackController = `${SettingService}/page-feedback`;
const PartnerController = `${SettingService}/partners`;
const ZoomController = `${SettingService}/zoom`;
const WebexIntegrationController = `${SettingService}/webex/integrations`;
const VideoConferenceProviderController = `${SettingService}/video-conference/providers`;
const TestimonialController = `${SettingService}/testimonials`;
const TeamMemberController = `${SettingService}/team-members`;
const PlatformFaqController = `${SettingService}/platform/faqs`;
const HomeAdvertisingController = `${SettingService}/homeAdvertising`;

export const SettingsService = {
    Contact: {
        Contacts: ContactController,
        ContactId: (contactId) => `${ContactController}/${contactId}`,
        Settings: `${ContactController}/settings`,
    },
    Culture: {
        Cultures: CultureController,
        CultureId: (cultureId) => `${CultureController}/${cultureId}`,
        Translate: (culture) => `${CultureController}/${culture}/translation`,
        TranslatePrefix: `${environment.apiUrl}${CultureController}/`,
        TranslateSuffix: `/translation`,
    },
    Currency: {
        Currencies: CurrencyController,
        CurrencyId: (currencyId) => `${CurrencyController}/${currencyId}`,
        CurrencyExporting: `${CurrencyController}/${SharedParams.Exporting}`,
    },
    CourseTabImage: {
        CourseTabImages: CourseTabImageController,
        CourseTabImageId: (courseTabImageId) => `${CourseTabImageController}/${courseTabImageId}`,
        ImageUploading: (courseTabImageId) => `${CourseTabImageController}/${courseTabImageId}/${SharedParams.Uploading}`,
    },
    Hint: {
        Hints: HintController,
        HintKey: (hintKey) => `${HintController}/${hintKey}`,
    },
    Tour: {
        Tours: TourController,
        TourName: (tourName) => `${TourController}/${tourName}`,
    },
    DynamicSignUpForm: {
        SignUpForms: DynamicSignUpFormController,
        RoleForm: (roleId) => `${DynamicSignUpFormController}/roleForm/${roleId}`,
        RoleAvailability: `${DynamicSignUpFormController}/roles/availability`,
        FieldSettings: (fieldId) => `${DynamicSignUpFormController}/fields/${fieldId}`,
    },
    HomeImage: {
        HomeImages: HomeImageController,
        ImageId: (imageId) => `${HomeImageController}/${imageId}`,
        SubImageId: (subImageId) => `${HomeImageController}/${subImageId}`,
        ImageType: (imageType) => `${HomeImageController}/image-type/${imageType}`,
        ImageUploading: (imageId) => `${HomeImageController}/${imageId}/${SharedParams.Uploading}`,
        SubImageUploading: (imageId) => `${HomeImageController}/${imageId}/sub-images/${SharedParams.Uploading}`,
        DeleteSubImage: (imageId, subImageId) => `${HomeImageController}/${imageId}/sub-images/${subImageId}`,
        UpdateStatus: (imageId) => `${HomeImageController}/${imageId}/${SharedParams.Status}`,
    },
    HomeSection: {
        Sections: HomeSectionController,
        SectionId: (sectionId) => `${HomeSectionController}/${sectionId}`,
        UpdateStatus: (sectionId) => `${HomeSectionController}/${sectionId}/${SharedParams.Status}`,
    },
    Identity: {
        Controller: IdentityController,
        IdentityId: (identityId) => `${IdentityController}/${identityId}`,
        ImageUploading: (identityId) => `${IdentityController}/${identityId}/images/${SharedParams.Uploading}`,
    },
    Localizations: {
        Controller: LocalizationsController,
        Sections: `${LocalizationsController}/sections`,
    },
    MessageCategory: {
        Categories: MessageCategoryController,
    },
    MessagingConfig: {
        Messaging: MessagingConfigController,
        EmailsConfig: `${MessagingConfigController}/emails/configuration`,
        EmailCheck: `${MessagingConfigController}/emails/check`,
        MessagesConfig: `${MessagingConfigController}/messages/configurations`,
        MessagesConfigByAction: (actionType) => `${MessagingConfigController}/messages/${actionType}/configurations`,
        MessagesConfigByCategory: (categoryId) => `${MessagingConfigController}/messages/category/${categoryId}/configurations`,
    },
    Notification: {
        Notifications: NotificationController,
        GetNotification: (notificationId: number) => `${NotificationController}/${notificationId}`,
        UnseenNotification:`${NotificationController}/unseen`,
        UpdateStatus: (notificationId) => `${NotificationController}/${notificationId}/${SharedParams.Status}`,
    },
    Organization: {
        Organizations: OrganizationController,
        OrganizationId: (organizationId) => `${OrganizationController}/${organizationId}`,
        OrganizationType: (organizationType) => `${OrganizationController}/type/${organizationType}`,
        OrganizationUsers: (organizationId) => `${OrganizationController}/${organizationId}/users`,
        CurrentUserOrganizations: `${OrganizationController}/currentUser`,
    },
    Page: {
        Pages: PageController,
        Active: `${PageController}/active`,
        PageType: (pageType) => `${PageController}/type/${pageType}`,
    },
    PageFeedback: {
        Controller: PageFeedbackController,
    },
    Partner: {
        Partners: PartnerController,
        ActivePartners: `${PartnerController}/active`,
        PartnerId: (partnerId) => `${PartnerController}/${partnerId}`,
        UpdateStatus: (partnerId) => `${PartnerController}/${partnerId}/${SharedParams.Status}`,
        UploadPartenerImage: (partnerId) => `${PartnerController}/${partnerId}/logo/${SharedParams.Uploading}`,
    },
    Zoom:{
        Controller: ZoomController,
        RegistrationToken : `${ZoomController}/registration-token`,
    },
    WebexIntegration: {
        Controller: WebexIntegrationController,
        AccessToken: `${WebexIntegrationController}/access-token`,
        RefreshToken: `${WebexIntegrationController}/refresh-token`,
        IntegrationId: (integrationid) => `${WebexIntegrationController}/${integrationid}`,
    },
    VideoConferenceProvider: {
        Providers: VideoConferenceProviderController,
        ProviderStatus: `${VideoConferenceProviderController}/${SharedParams.Status}`,
        ProviderTypeConnection: (providerType) =>
            `${VideoConferenceProviderController}/type/${providerType}/connection`,
    },
    Testimonial: {
        Controller: TestimonialController,
        Active: `${TestimonialController}/active`,
        TestimonialId: (testimonialId) => `${TestimonialController}/${testimonialId}`,
        TestimonialStatus: (testimonialId) => `${TestimonialController}/${testimonialId}/${SharedParams.Status}`,
        ImageUpload: (testimonialId) => `${TestimonialController}/${testimonialId}/image/${SharedParams.Uploading}`,
    },
    TeamMember: {
        Controller: TeamMemberController,
        MemberId: (memberId) => `${TeamMemberController}/${memberId}`,
        MembersDropdown: `${TeamMemberController}/${SharedParams.Dropdown}`,
        MembersStatus: `${TeamMemberController}/${SharedParams.Status}`,
        UploadMemberImage: (memberId) => `${TeamMemberController}/${memberId}/image/${SharedParams.Uploading}`,
    },
    PlatformFaq: {
        Controller: PlatformFaqController,
        QuestionId: (questionId) => `${PlatformFaqController}/${questionId}`,
        ListByLanguage: (languageId) => `${PlatformFaqController}/language/${languageId}`,
        AllQuestions: `${PlatformFaqController}/questions`,
    },
    HomeAdvertising: {
        Controller: HomeAdvertisingController,
        GetPublished: `${HomeAdvertisingController}/GetPublishedAdvertisements`
    },
};
